<mat-form-field class="input-field">
  <mat-select placeholder="State" formControlName="{{ formControlName }}" [(ngModel)]="selectedValue">
    <mat-option *ngFor="let value of allValues" [value]="value">{{ value }}</mat-option>
  </mat-select>
  <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>